import {
  ApiRoute,
  CreateQuizCompletion,
  Quiz,
  QuizCompletion,
  QuizCompletionSchema,
  QuizRecommendations,
  QuizRecommendationsSchema,
  QuizSchema,
  UpdateQuizAnswer,
  UpdateQuizCompletion,
  getApiRoute
} from "@garther/interfaces";
import { z } from "zod";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class QuizApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.QUIZ),
      requireAuth: true
    });
  }

  // Get all active quizzes
  async getQuizzes(): Promise<Quiz[]> {
    return await this.get("", z.array(QuizSchema), { requireAuth: false });
  }

  // Get current user's quiz data
  async getMyQuizData(): Promise<QuizCompletion> {
    return await this.get("me", QuizCompletionSchema, { requireAuth: true });
  }

  // Get current user's quiz recommendations
  async getMyQuizRecommendations(): Promise<QuizRecommendations> {
    return await this.get("me/recommendations", QuizRecommendationsSchema, {
      requireAuth: true
    });
  }

  // Create current user's quiz data
  async createMyQuizData(quizData: CreateQuizCompletion): Promise<QuizCompletion> {
    return await this.post("me", QuizCompletionSchema, quizData, {
      requireAuth: true
    });
  }

  // Update current user's quiz data
  async updateMyQuizData(updateData: UpdateQuizCompletion): Promise<QuizCompletion> {
    return await this.put("me", QuizCompletionSchema, updateData, {
      requireAuth: true
    });
  }

  // Update current user's quiz answer
  async updateMyAnswer(answerUpdate: UpdateQuizAnswer): Promise<QuizCompletion> {
    return await this.put("me/answer", QuizCompletionSchema, answerUpdate, {
      requireAuth: true
    });
  }

  // Complete current user's quiz
  async completeMyQuiz(completion: CreateQuizCompletion): Promise<QuizCompletion> {
    return await this.post("me/complete", QuizCompletionSchema, completion, {
      requireAuth: true
    });
  }

  async deleteMyQuizData(): Promise<QuizCompletion> {
    return await this.delete("me", QuizCompletionSchema, { requireAuth: true });
  }
}
